export enum AnalyticsEvents {
  ACCESS_SWAN_DASHBOARD_CLICKED = 'Access Swan Dashboard Clicked',
  ACTIVATE_SIBILL_PHYSICAL_CARD_CLICKED = 'Activate Sibill Physical Card Clicked',
  ANALYTICS_COUNTERPART_SELECTED = 'Analytics Counterpart Selected',
  ANALYTICS_DATE_FILTER_USED = 'Analytics Date Filter Used',
  ANALYTICS_DEVICE_SELECTED = 'Analytics Device Selected',
  ANALYTICS_PRODUCT_SEARCH_BAR_USED = 'Analytics Product Search Bar Used',
  ANALYTICS_TABLE_ACCORDION_CLICKED = 'Analytics Table Accordion Clicked',
  AUTOCATEGORIZATION_STATUS_CHANGED = 'Autocategorization Status Changed',
  BANK_ACCOUNT_ADD_BUTTON_CLICKED = 'Bank Account Add Button Clicked',
  BANK_ACCOUNT_ADD_PROCEED_CLICKED = 'Bank Account Add Proceed Clicked',
  BANK_ACCOUNT_CONNECT_CLICKED = 'Bank Account Connect Clicked',
  BANK_ACCOUNT_DELETED = 'Bank Account Deleted',
  BANK_ACCOUNT_DISABLE_CLICKED = 'Bank Account Disable Clicked',
  BANK_ACCOUNT_EXPORTED = 'Bank Account Exported',
  BANK_ACCOUNT_HIDE_SHOW_BALANCES_BUTTON_CLICKED = 'Bank Accounts Hide/Show Balances Button Clicked',
  BANK_ACCOUNT_OPEN_MOVEMENTS = 'Bank Account Open Movements',
  BANK_ACCOUNT_OPEN_WEB_BANKING = 'Bank Account Open Web Banking SWAN',
  BANK_ACCOUNT_REQUEST_DELETE = 'Bank Account Request Delete',
  BANK_ACCOUNT_UPDATED = 'Bank Account Updated',
  BILLS_CATEGORIES_BULK_UPDATED = 'Bills Categories Bulk Updated',
  BILLS_CATEGORY_ASSIGNED = 'Bills Category Assigned',
  BILLS_CATEGORY_EDITED = 'Bills Category Edited',
  BILLS_EXPORTED = 'Bills Exported',
  BILLS_FILTER_USED = 'Bills Filter Used',
  BILLS_SEARCH_BAR_USED = 'Bills Search Bar Used',
  BILLS_SUBCATEGORY_ASSIGNED = 'Bills Subcategory Assigned',
  BILLS_SUBCATEGORY_EDITED = 'Bills Subcategory Edited',
  BOOKKEEPING_ACCOUNT_CREATED = 'Bookkeeping Account Created',
  BOOKKEEPING_ACCOUNT_DELETED = 'Bookkeeping Account Deleted',
  BOOKKEEPING_ACCOUNT_UPDATED = 'Bookkeeping Account Updated',
  BOOKKEEPING_BANK_ACCOUNT_LINKED = 'Bookkeeping Bank Account Linked',
  BOOKKEEPING_BANK_ACCOUNT_UNLINKED = 'Bookkeeping Bank Account Unlinked',
  BOOKKEEPING_LEDGER_DOWNLOADED = 'Bookkeeping Ledger Downloaded',
  BOOKKEEPING_LEDGER_SHARED = 'Bookkeeping Ledger Shared',
  BOOKKEEPING_TRANSACTIONS_FILTER_USED = 'Bookkeeping Transactions Filter Used',
  BOOKKEEPING_TRANSACTIONS_SEARCH_BAR_USED = 'Bookkeeping Transactions Search Bar Used',
  BOOKKEEPING_VAT_INVOICE_PREVIEW_VIEWED = 'Bookkeeping VAT Invoice Preview Viewed',
  BOOKKEEPING_VAT_REGISTRATION_ENTRY_ADDED = 'Bookkeeping VAT Registration Entry Added',
  BOOKKEEPING_VAT_REGISTRATION_ENTRY_DELETED = 'Bookkeeping VAT Registration Entry Deleted',
  BOOKKEEPING_VAT_REGISTRATION_GROUP_ITEMS_CONFIRMED = 'Bookkeeping VAT Registration Group Items Confirmed',
  BOOKKEEPING_VAT_REGISTRATION_GROUP_ITEMS_OPENED = 'Bookkeeping VAT Registration Group Items Opened',
  BUDGET_VALUE_INSERTED = 'Budget Value Inserted',
  BUDGET_VALUE_MADE_RECURRENT = 'Budget Value Made Recurrent',
  BUDGET_VALUE_SEQUENCE_DELETED = 'Budget Value Sequence Deleted',
  BUDGET_VALUE_UPDATED = 'Budget Value Updated',
  CANCEL_CUSTOM_FILTER_EDITS_CLICKED = 'Cancel Custom Filter Edits Clicked',
  CARD_LIST_ADD_CARD_BUTTON_CLICKED = 'Card List Add Card Button Clicked',
  CASHBOOK_EXPORTED = 'Cashbook Exported',
  CASHFLOW_CATEGORIES_SORTED = 'Cashflow Categories Sorted',
  CASHFLOW_CATEGORY_HIDDEN = 'Cashflow Category Hidden',
  CASHFLOW_DELETE_CATEGORY_BUDGET_CLICKED = 'Cashflow Delete Category Budget Clicked',
  CASHFLOW_DELETE_SUBCATEGORY_BUDGET_CLICKED = 'Cashflow Delete Subcategory Budget Clicked',
  CASHFLOW_DISPLAY_CATEGORY_CLICKED = 'Cashflow Display Category Clicked',
  CASHFLOW_DISPLAY_SUBCATEGORY_CLICKED = 'Cashflow Display Subcategory Clicked',
  CASHFLOW_EDIT_CATEGORY_CLICKED = 'Cashflow Edit Category Clicked',
  CASHFLOW_EDIT_SUBCATEGORY_CLICKED = 'Cashflow Edit Subcategory Clicked',
  CASHFLOW_EXPORTED = 'Cashflow Exported',
  CASHFLOW_SUBCATEGORIES_COLLAPSED = 'Cashflow Subcategories Collapsed',
  CASHFLOW_SUBCATEGORIES_EXPANDED = 'Cashflow Subcategories Expanded',
  CASHFLOW_SUBCATEGORY_HIDDEN = 'Cashflow Subcategory Hidden',
  CASHFLOW_VIEW_ALL_ITEMS_CLICKED = 'Cashflow View All Items Clicked',
  CASHFLOW_VIEW_CARD_DETAILS_CLICKED = 'Cashflow View Card Details Clicked',
  CASHFLOW_VIEW_UTILISED = 'Cashflow View Utilised',
  CATEGORY_ASSIGNED_TO_COUNTERPART = 'Category Assigned To Counterpart',
  CATEGORY_CREATED = 'Category Created',
  CATEGORY_DELETED = 'Category Deleted',
  CHAT_CREATED = 'Chat Created',
  CHAT_DELETED = 'Chat Deleted',
  CHAT_MESSAGE_COPIED = 'Copy Chat Message Clicked',
  CHAT_MESSAGE_LIKED = 'Like Chat Message Clicked',
  CHAT_MESSAGE_SENT = 'Chat Message Sent',
  CHAT_MESSAGE_UNLIKED = 'Unlike Chat Message Clicked',
  CHAT_NEW_STARTED = 'Create New Chat Clicked',
  CHAT_STARTER_SELECTED = 'Chat Suggested Topic Clicked',
  CHAT_SUGGESTION_SELECTED = 'Chat Suggested Question Clicked',
  CHAT_SWITCHED = 'Open Existing Chat Clicked',
  CHAT_TABLE_EXPORTED = 'Chat Table Export Clicked',
  COLUMN_PICKER_CLICKED = 'Column Picker Clicked',
  COLUMN_VISIBILITY_TOGGLED = 'Column Visibility Toggled',
  COMPANY_CREATED = 'Company Created',
  COMPANY_DATA_UPDATED = 'Company Updated',
  COMPANY_IDENTITY_DATA_UPDATED = 'Company Data Updated',
  COMPANY_LOGO_UPLOADED = 'Company Logo Uploaded',
  COMPANY_SWITCHED = 'Company Switched',
  CONSENT_DISABLED = 'Consent Disabled',
  CONSENT_ENABLED = 'Consent Enabled',
  CONSENT_PROCEED_CLICKED = 'Consent Proceed Clicked',
  CONSENT_REAUTHORIZED = 'Consent Reauthorized',
  CONTACT_FORM_VISITED = 'Contact Form Visited',
  COUNTERPART_CREATED = 'Counterpart Created',
  COUNTERPART_CREATION_STARTED = 'Counterpart Creation Started',
  COUNTERPARTS_EXPORTED = 'Counterparts Exported',
  COUNTERPARTS_FILTER_USED = 'Counterparts Filter Used',
  COUNTERPARTS_MERGED = 'Counterparts Merged',
  COUNTERPARTS_SEARCH_BAR_USED = 'Counterparts Search Bar Used',
  CREATE_CREDIT_NOTE_CLICKED = 'Create Credit Note Clicked',
  CREATE_DDT_CLICKED = 'Create DDT Clicked',
  CREATE_INVOICE_CLICKED = 'Create Invoice Clicked',
  CREATE_NEW_DOCUMENT_CLICKED = 'Create New Document Clicked',
  CUSTOM_FILTER_ACCORDION_CLICKED = 'Custom Filters Accordion Clicked',
  CUSTOM_FILTER_DELETED = 'Custom Filter Deleted',
  CUSTOM_FILTER_EDITED = 'Custom Filter Edited',
  CUSTOM_FILTER_REMOVED = 'Custom Filter Removed',
  CUSTOM_FILTER_RENAMED = 'Custom Filter Renamed',
  CUSTOM_FILTER_SAVED = 'Custom Filter Saved',
  CUSTOM_FILTER_USED = 'Custom Filter Used',
  DELETE_DOCUMENT_CLICKED = 'Delete Document Clicked',

  DELETE_SIBILL_CARD_CLICKED = 'Delete Sibill Card Clicked',
  DELIVERY_NOTES_EDITED = 'Delivery Note Edited',
  DELIVERY_NOTES_FILTER_USED = 'Delivery Notes Filter Used',
  DELIVERY_NOTES_QUICK_FILTER_USED = 'Delivery Notes Quick Filter Used',
  DELIVERY_NOTES_SEARCH_BAR_USED = 'Delivery Notes Search Bar Used',
  DOCUMENT_ATTACHMENT_CREATED = 'Document Attachment Created',
  DOCUMENT_ATTACHMENT_DOWNLOADED = 'Document Attachment Downloaded',
  DOCUMENT_ATTACHMENT_REMOVED = 'Document Attachment Removed',
  DOCUMENT_BILL_EDITED = 'Bill Edited',
  DOCUMENT_COPY_DOWNLOADED = 'Document Copy Downloaded',
  DOCUMENT_COPY_PRINTED = 'Document Copy Printed',
  DOCUMENT_COPY_SUBMISSION_STARTED = 'Document Copy Submission Started',
  DOCUMENT_COPY_SUBMITTED = 'Document Copy Submitted',
  DOCUMENT_CREATION_STARTED = 'Document Creation Started',
  DOCUMENT_DELETED = 'Flow Generator Deleted',
  DOCUMENT_DISCARDED_SUBMISSION_STARTED = 'Document Discarded Submission Started',
  DOCUMENT_DRAFT_DOWNLOADED = 'Document Draft Downloaded',
  DOCUMENT_DRAFT_PRINTED = 'Document Draft Printed',
  DOCUMENT_DRAFT_SUBMISSION_STARTED = 'Document Draft Submission Started',
  DOCUMENT_DRAFT_SUBMITTED = 'Document Draft Submitted',
  DOCUMENT_HIDDEN = 'Document Hidden',
  DOCUMENT_INVOICE_EDITED = 'Invoice Edited',
  DOCUMENT_ISSUED = 'Document Issued',
  DOCUMENT_PARSING_RECEIVED = 'Document Parsing Received',
  DOCUMENT_PARSING_REQUEST_TIMED_OUT = 'Document Parsing Request Timed Out',
  DOCUMENT_PARSING_REQUESTED = 'Document Parsing Requested',
  DOCUMENT_REFUSED_SUBMISSION_STARTED = 'Document Refused Submission Started',
  DOCUMENT_UNHIDDEN = 'Document Unhidden',
  DOCUMENTS_ARCHIVE_EXPORTED = 'Documents Archive Exported',
  DOCUMENTS_CATEGORIES_BULK_UPDATED = 'Documents Categories Bulk Updated',
  DOWNLOAD_DOCUMENT_XML_CLICKED = 'Download Document XML Clicked',
  DUPLICATE_DOCUMENT_CLICKED = 'Duplicate Document Clicked',
  EDIT_CUSTOM_FILTER_CLICKED = 'Edit Custom Filter Clicked',
  EDIT_DOCUMENT_CLICKED = 'Edit Document Clicked',
  F24_BUTTON_CLICKED = 'F24 Button Clicked',
  F24_DELETE_CLICKED = 'F24 Delete Clicked',
  F24_FIRST_PAYMENT_COMPLETED = 'First F24 Payment Completed',
  F24_OCR_UPLOAD_CANCELLED = 'F24 OCR Upload Cancelled',
  F24_ORIGINAL_DOWNLOAD_CLICKED = 'F24 Original Download Clicked',
  F24_PAY_CLICKED = 'F24 Pay Clicked',
  F24_PAYMENT_CLOSE = 'F24 Payment Closed',
  F24_PAYMENT_COMPLETED = 'F24 Payment Completed',
  F24_PAYMENT_STARTED = 'F24 Payment Started',
  F24_PAYMENT_STEP_CHANGE = 'F24 Payment Step Change',
  F24_RECEIPT_DOWNLOAD_CLICKED = 'F24 Receipt Download Clicked',
  F24_ROW_CLICKED = 'F24 Row Clicked',
  FAQ_OPENED = 'FAQ Opened',
  FAQ_PAGE_VISITED = 'FAQ Page Visited',
  FIRST_CATEGORISATION_RULE_CREATION_COMPLETED = 'First Categorization Rule Creation Completed',
  FIRST_CATEGORISATION_RULE_CREATION_STARTED = 'First Categorization Rule Creation Started',
  FIRST_CATEGORY_ASSIGNED = 'First Category Assigned',
  FIRST_OUTSTANDING_RULE_CREATION_COMPLETED = 'First Outstanding Rule Creation Completed',
  FIRST_OUTSTANDING_RULE_CREATION_STARTED = 'First Outstanding Rule Creation Started',
  FLOW_DELETED = 'Flow Deleted',
  FLOW_NOTE_CREATED = 'Flow Note Created',
  FLOW_UPDATED = 'Flow Updated',
  FLOWS_BULK_DELETED = 'Flows Bulk Deleted',
  FLOWS_BULK_UPDATED = 'Flows Bulk Updated',
  FLOWS_CATEGORY_ASSIGNED = 'Flows Category Assigned',
  FLOWS_CATEGORY_EDITED = 'Flows Category Edited',
  FLOWS_SUBCATEGORY_ASSIGNED = 'Flows Subcategory Assigned',
  FLOWS_SUBCATEGORY_EDITED = 'Flows Subcategory Edited',
  INVOICE_VIEWED = 'Invoice Viewed',
  INVOICES_BULK_UPDATED = 'Invoices Bulk Updated',
  INVOICES_CATEGORIES_BULK_UPDATED = 'Invoices Categories Bulk Updated',
  INVOICES_CATEGORY_ASSIGNED = 'Invoices Category Assigned',
  INVOICES_CATEGORY_EDITED = 'Invoices Category Edited',
  INVOICES_EXPORTED = 'Invoices Exported',
  INVOICES_FILTER_USED = 'Invoices Filter Used',
  INVOICES_IMPORT_COMPLETED = 'Invoices Import Completed',
  INVOICES_IMPORT_STARTED = 'Invoices Import Started',
  INVOICES_QUICK_FILTER_USED = 'Invoices Quick Filter Used',
  INVOICES_SEARCH_BAR_USED = 'Invoices Search Bar Used',
  INVOICES_SUBCATEGORY_ASSIGNED = 'Invoices Subcategory Assigned',
  INVOICES_SUBCATEGORY_EDITED = 'Invoices Subcategory Edited',
  INVOICING_CATALOG_ADD_PRODUCT_CLICKED = 'Invoicing Catalog Add Product Clicked',
  INVOICING_CATALOG_EDIT_PRODUCT_CLICKED = 'Invoicing Catalog Edit Product Clicked',
  INVOICING_CATALOG_PRODUCT_ADDED = 'Invoicing Catalog Product Added',
  INVOICING_CATALOG_PRODUCT_DELETED = 'Invoicing Catalog Product Deleted',
  INVOICING_CATALOG_PRODUCT_EDITED = 'Invoicing Catalog Product Edited',
  INVOICING_CATALOG_SEARCH_BAR_USED = 'Invoicing Catalog Search Bar Used',
  INVOICING_CLOSE_BANNER_CLICKED = 'Invoicing Close Banner Clicked',
  INVOICING_MORE_INFO_BANNER_CLICKED = 'Invoicing More Info Banner Clicked',
  INVOICING_REQUEST_COMPLETED = 'Invoicing Request Completed',
  INVOICING_REQUEST_STARTED = 'Invoicing Request Started',
  JETHR_ACTIVATE_INTEGRATION_CLICKED = 'JetHR Activate Integration Clicked',
  JETHR_CLOSE_BANNER_CLICKED = 'JetHR Close Banner Clicked',
  JETHR_DISCOVER_INTEGRATION_CLICKED = 'JetHR Discover Integration Clicked',
  JETHR_MORE_INFO_BANNER_CLICKED = 'JetHR More Info Banner Clicked',
  LIPE_EDIT_DIALOG_OPENED = 'LIPE Edit Dialog Opened',
  LIPE_REGENERATED = 'LIPE Regenerated Manually',
  LIPE_TRANSMITTED = 'LIPE Transmitted',
  MANUAL_ACCOUNT_BANK_LINKS_UPDATED = 'Manual Account Bank Links Updated',
  MERGE_COUNTERPARTS_MODAL_OPENED = 'Merge Counterparts Modal Opened',
  NAVIGATION_SECTION_CLICKED = 'Navigation Section Clicked',
  NAVIGATION_TAB_CLICKED = 'Navigation Tab Clicked',
  ONBOARDING_SIBILL_CARD = 'Onboarding Sibill Card',
  ONEOFF_FLOW_CREATED = 'OneOff Flow Created',
  ONEOFF_FLOW_CREATION_STARTED = 'OneOff Flow Creation Started',
  OUTSTANDING_CHART_FILTERS_USED = 'Outstanding Chart Filters Used',
  OUTSTANDING_QUICK_FILTER_REMOVED = 'Outstanding Quick Filter Removed',
  OUTSTANDING_QUICK_FILTER_USED = 'Outstanding Quick Filter Used',
  OUTSTANDING_RULE_CREATION_COMPLETED = 'Outstanding Rule Creation Completed',
  OUTSTANDING_RULE_CREATION_STARTED = 'Outstanding Rule Creation Started',
  OUTSTANDING_RULE_EDITED = 'Outstanding Rule Edited',
  OUTSTANDING_SUMMARY_CARD_MAIN_CTA_CLICKED = 'Outstanding Summary Card Main CTA Clicked',
  OUTSTANDING_SUMMARY_PERIOD_SELECTED = 'Outstanding Summary Period Selected',
  OUTSTANDING_TAB_CLICKED = 'Outstanding Tab Clicked',
  OUTSTANDING_TABLE_FILTERS_USED = 'Outstanding Table Filters Used',
  PASSKEY_CREATED = 'Passkey Created',
  PASSKEY_DELETED = 'Passkey Deleted',
  PAYMENT_ACCOUNT_ASSIGNED_TO_COUNTERPART = 'Payment Account Assigned To Counterpart',
  PAYMENT_AUTHORIZATION_STARTED = 'Payment Authorization Started',
  PAYMENT_BANK_ACCOUNT_DISCONNECTED_ALERT_BUTTON_CLICKED = 'Payment Bank Account Disconnected Alert Button Clicked',
  PAYMENT_DOWNLOAD_ATTACHMENT = 'Payment Download Attachment',
  PAYMENT_DOWNLOAD_STATEMENT = 'Payment Download Statement',
  PAYMENT_FORM_INTERACTION = 'Payment Form Interaction',
  PAYMENT_OPEN_STATEMENT_BUTTON_CLICKED = 'Payment Open Statement Button Clicked',
  PAYMENT_REMINDER_CREATE_CLICKED = 'Payment Reminder Create Clicked',
  PAYMENT_REMINDER_CREATED = 'Payment Reminder Created',
  PAYMENT_REMINDER_DELETE_CLICKED = 'Payment Reminder Delete Clicked',
  PAYMENT_REMINDER_DELETED = 'Payment Reminder Deleted',
  PAYMENT_REMINDER_EDIT_CLICKED = 'Payment Reminder Edit Clicked',
  PAYMENT_REMINDER_EDITED = 'Payment Reminder Edited',
  PAYMENT_REMINDER_FILTER_USED = 'Payment Reminder Filter Used',
  PAYMENT_REMINDER_MODAL_CTA_CLICKED = 'Payment Reminder Modal CTA Clicked',
  PAYMENT_REMINDER_ROW_CLICKED = 'Payment Reminder Row Clicked',
  PAYMENT_REMINDER_SEARCH_BAR_USED = 'Payment Reminder Search Bar Used',
  PAYMENT_REMINDER_STATUS_CHANGED = 'Payment Reminder Status Changed',
  PAYMENT_REMINDERS_HISTORY_ACCORDION_CLICKED = 'Payment Reminders History Accordion Clicked',
  PAYMENT_SCHEDULE_REMINDER_SENT = 'Payment Schedule Reminder Sent',
  PAYMENT_STARTED = 'Payment Started',
  PAYMENT_STARTED_ADDITIONAL_SCHEDULE_SELECTED = 'Payment Started Additional Schedule Selected',
  PAYMENT_STARTED_DOCS_ACCORDION_CLICKED = 'Payment Started Docs Accordion Clicked',
  PAYMENT_STARTED_MAIN_CTA_CLICKED = 'Payment Started Main CTA Clicked',
  PAYMENT_STARTED_NOTIFY_RECIPIENT_CLICKED = 'Payment Started Notify Recipient Clicked',
  PAYMENT_STARTED_SCHEDULES_SEARCH_BAR_USED = 'Payment Started Schedules Search Bar Used',
  PAYMENT_STARTED_SCHEDULES_SORTING_SELECTED = 'Payment Started Schedules Sorting Selected',
  PAYMENT_STARTED_TAB_CLICKED = 'Payment Started Tab Clicked',
  PAYMENT_STATUS_UPDATE_MANUALLY = 'Payment Status Update Manually',
  PAYMENT_VOP_COMPLETED = 'Payment VOP Completed',
  PAYMENT_VOP_STARTED = 'Payment VOP Started',
  PAYMENTS_EMPTY_STATE_BULK_PAYMENTS_CLICKED = 'Payments Empty State Bulk Payments Clicked',
  PAYMENTS_EMPTY_STATE_MAKE_PAYMENT_CLICKED = 'Payments Empty State Make Payment Clicked',
  PAYMENTS_EMPTY_STATE_PAY_F24_CLICKED = 'Payments Empty State Pay F24 Clicked',
  PAYMENTS_EMPTY_STATE_PAY_F24_NOT_ACTIVE_CLICKED = 'Payments Empty State Pay F24 Not Active Clicked',
  PAYMENTS_EMPTY_STATE_PAY_FROM_OUTSTANDING_CLICKED = 'Payments Empty State Pay From Outstanding Clicked',
  PAYMENTS_EMPTY_STATE_PAY_FROM_OUTSTANDING_CONNECTED_CLICKED = 'Payments Empty State Pay From Outstanding Connected Clicked',
  PAYMENTS_EMPTY_STATE_PAY_FROM_PDF_CLICKED = 'Payments Empty State Pay From PDF Clicked',
  PAYMENTS_IMPORT_COMPLETED = 'Payment Import Completed',
  PAYMENTS_IMPORT_STARTED = 'Payment Import Started',
  PAYMENTS_QUICK_ACTION_CLICKED = 'Payments Quick Action Clicked',
  PAYMENTS_QUICK_FILTER_USED = 'Payments Quick Filter Used',
  PAYMENTS_TABLE_FILTER_USED = 'Payments Filter Used',
  PAYMENTS_TABLE_SEARCH_BAR_USED = 'Payments Search Bar Used',
  PROVISIONAL_BALANCE_DOWNLOADED = 'Provisional Balance Downloaded',
  PROVISIONAL_BALANCE_SHARED = 'Provisional Balance Shared',
  QUOTE_EDITED = 'Quote Edited',
  QUOTES_FILTER_USED = 'Quotes Filter Used',
  QUOTES_QUICK_FILTER_USED = 'Quotes Quick Filter Used',
  QUOTES_SEARCH_BAR_USED = 'Quotes Search Bar Used',
  RECONCILE_TRANSACTION_MODAL_FILTER_USED = 'Reconcile Transaction Modal Filter Used',
  RECONCILE_TRANSACTION_MODAL_SEARCH_BAR_USED = 'Reconcile Transaction Modal Search Bar Used',
  RECONCILIATION_CREATED = 'Reconciliation Created',
  RECONCILIATION_DELETED = 'Reconciliation Deleted',
  RECONCILIATION_MATCHED = 'Reconciliation Matched',
  RECONCILIATION_REJECTED = 'Reconciliation Rejected',
  RECONCILIATIONS_FILTER_USED = 'Reconciliations Filter Used',
  RECONCILIATIONS_SEARCH_BAR_USED = 'Reconciliations Search Bar Used',
  RECURRENCE_CREATED = 'Recurrence Created',
  RECURRENCE_CREATION_STARTED = 'Recurrence Creation Started',
  RECURRENCE_DELETED = 'Recurrence Deleted',
  RECURRENCE_UPDATED = 'Recurrence Updated',
  REFERRAL_INVITE_COUNTERPARTS_FILTER_USED = 'Referral Invite Counterparts Filter Used',
  REFERRAL_INVITE_COUNTERPARTS_SEARCH_BAR_USED = 'Referral Invite Counterparts Search Bar Used',
  REFERRAL_LINK_COPIED = 'Referral Link Copied',
  REFERRAL_LINK_SHARED = 'Referral Link Shared',
  REFERRAL_MANUAL_SHARED = 'Referral Manual Shared',
  REGISTRATION_TEMPLATE_APPLIED = 'Registration Template Applied',
  REGISTRATION_TEMPLATE_CREATED = 'Registration Template Created',
  RENAME_CUSTOM_FILTER_CLICKED = 'Rename Custom Filter Clicked',
  RESUME_SIBILL_CARD_CLICKED = 'Resume Sibill Card Clicked',
  RIGHT_SIDEBAR_CLOSED = 'Right Sidebar Closed',
  RIGHT_SIDEBAR_OPENED = 'Right Sidebar Opened',
  RIGHT_SIDEBAR_TAB_CLICKED = 'Right Sidebar Tab Clicked',
  SAVE_CUSTOM_FILTER_CLICKED = 'Save Custom Filter Clicked',
  SCHEDULE_QUICK_FILTER_USED = 'Schedule Quick Filter Used',
  SCHEDULE_SEARCH_BAR_USED = 'Schedule Search Bar Used',
  SCHEDULED_PAYMENT_DELETE_CLICKED = 'Scheduled Payment Delete Clicked',
  SCHEDULED_PAYMENT_DELETED = 'Scheduled Payment Deleted',
  SECOND_COMPANIES_CREATION_STARTED = 'Second Companies creation started',
  SEND_DOCUMENT_COPY_CLICKED = 'Send Document Copy Clicked',
  SEND_PAYMENT_REMINDER_CLICKED = 'Send Payment Reminder Clicked',
  SHARE_CASHBOOK_STARTED = 'Share Cashbook Started',
  SHOW_SIBILL_CARD_PIN_CLICKED = 'Show Sibill Card Pin Clicked',
  SHOW_SIBILL_CARD_SENSITIVE_INFO_CLICKED = 'Show Sibill Card Sensitive Info Clicked',
  SIBILL_ACCOUNT_MORE_INFO_BANNER_CLICKED = 'Sibill Account More Info Banner Clicked',
  SIBILL_ACCOUNT_REQUEST_STARTED = 'Sibill Account Request Started',
  SIBILL_ACCOUNT_USER_MANAGEMENT_PERMISSION_ENABLED = 'Sibill Account User Management Permission Enabled',
  SIBILL_CARD_REQUEST_STARTED = 'Sibill Card Request Started',
  SIGNED_IN = 'Signed In',
  SIGNED_OUT = 'Signed Out',
  SIGNED_UP = 'Signed Up',
  SIGNUP_EMAIL_VERIFICATION_SUBMITTED = 'Signup Email Verification Submitted',
  SUBCATEGORY_CREATED = 'Subcategory Created',
  SUBCATEGORY_DELETED = 'Subcategory Deleted',
  SUBSCRIPTION_ADD_PAYMENT_METHOD_BUTTON_CLICKED = 'Subscription Add Payment Method Button Clicked',
  SUBSCRIPTION_CREATED = 'Subscription Created',
  SUBSCRIPTION_MAKE_PAYMENT_BUTTON_CLICKED = 'Subscription Make Payment Button Clicked',
  SUPPORT_CHAT_HIDDEN = 'Support Chat Hidden',
  SWAN_CLOSE_BANNER_CLICKED = 'Swan Close Banner Clicked',
  SWAN_MORE_INFO_BANNER_CLICKED = 'Swan More Info Banner Clicked',
  TEMPORARY_SUSPEND_SIBILL_CARD_CLICKED = 'Temporary Suspend Sibill Card Clicked',
  TRANSACTION_ALLOCATION_CREATED = 'Transaction Allocation Created',
  TRANSACTION_ALLOCATION_DELETED = 'Transaction Allocation Deleted',
  TRANSACTION_ATTACHMENT_CREATED = 'Transaction Attachment Created',
  TRANSACTION_ATTACHMENT_DOWNLOADED = 'Transaction Attachment Downloaded',
  TRANSACTION_ATTACHMENT_REMOVED = 'Transaction Attachment Removed',
  TRANSACTION_CATEGORIES_BULK_UPDATED = 'Transaction Categories Bulk Updated',
  TRANSACTION_CATEGORIZATION_RULE_CREATION_COMPLETED = 'Transaction Categorization Rule Creation Completed',
  TRANSACTION_CATEGORIZATION_RULE_CREATION_STARTED = 'Transaction Categorization Rule Creation Started',
  TRANSACTION_CATEGORIZATION_RULE_EDITED = 'Transaction Categorization Rule Edited',
  TRANSACTION_CATEGORY_ASSIGNED = 'Transaction Category Assigned',
  TRANSACTION_CATEGORY_EDITED = 'Transaction Category Edited',
  TRANSACTION_CREATED = 'Transaction Created',
  TRANSACTION_DELETED = 'Transaction Deleted',
  TRANSACTION_FILTER_USED = 'Transaction Filter Used',
  TRANSACTION_HIDDEN = 'Transaction Hidden',
  TRANSACTION_HISTORY_REQUESTED = 'Transaction History Requested',
  TRANSACTION_NOTE_CREATED = 'Transaction Note Created',
  TRANSACTION_QUICK_FILTER_USED = 'Transaction Quick Filter Used',
  TRANSACTION_RULE_FILTER_USED = 'Transaction Rule Filter Used',
  TRANSACTION_RULE_SEARCH_BAR_USED = 'Transaction Rule Search Bar Used',
  TRANSACTION_SEARCH_BAR_USED = 'Transaction Search Bar Used',
  TRANSACTION_SUBCATEGORY_ASSIGNED = 'Transaction Subcategory Assigned',
  TRANSACTION_SUBCATEGORY_EDITED = 'Transaction Subcategory Edited',
  TRANSACTION_UNHIDDEN = 'Transaction Unhidden',
  TRANSACTION_UPDATED = 'Transaction Updated',
  TRANSACTION_VERIFIED = 'Transaction Verified',
  TRANSACTIONS_EXPORT_XML_ABANDONED = 'Transactions Export XML Abandoned',
  TRANSACTIONS_EXPORT_XML_CLICKED = 'Transactions Export XML Clicked',
  TRANSACTIONS_EXPORTED = 'Transactions Exported',
  TRANSACTIONS_EXPORTED_XML = 'Transactions Exported XML',
  TRANSACTIONS_IMPORT_COMPLETED = 'User Transactions Import Completed',
  TRANSACTIONS_IMPORT_STARTED = 'User Transactions Import Started',
  UPDATE_SIBILL_CARD_CLICKED = 'Update Sibill Card Clicked',
  USER_BANK_ACCOUNT_BANNER_CLICKED = 'User Bank Account Banner Clicked',
  USER_DELETED = 'User Deleted',
  USER_EDIT_PERMISSIONS_BUTTON_CLICKED = 'User Edit Permissions Button Clicked',
  USER_INVITE_BUTTON_CLICKED = 'User Invite Button Clicked',
  USER_INVITED = 'User Invited',
  USER_PROFILE_CHANGED = 'User Profile Changed',
  VAT_ENTRIES_PREDICTIONS_RECEIVED = 'VAT Entries Predictions Received',
  VAT_ENTRIES_PREDICTIONS_REQUESTED = 'VAT Entries Predictions Requested',
  VAT_ENTRIES_PREDICTIONS_TIMED_OUT = 'VAT Entries Predictions Timed Out',
  VIEW_DOCUMENT_PREVIEW_CLICKED = 'View Document Preview Clicked',
}
